import QuizButtonGroup from "gatsby-theme-dettol/src/components/NewQuiz/QuizButtonGroup/QuizButtonGroup"

import "./QuizButtonGroupOverride.scss"

export default QuizButtonGroup